import { LazyModule } from 'owa-bundling';
import { createLazyApolloComponent } from 'owa-apollo-component';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "MailModule"*/ './lazyIndex'), {
    name: 'MailModule',
});

// Delay loaded components
// Need to be wrapped with lazy apollo component so that the component is wrapped with the apollo provider
// and apollo client instance is available in the apollo hooks
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createLazyApolloComponent called at module scope is not allowed. This may cause unwanted side effects. */
export const MailLeftPaneAsOverlay = createLazyApolloComponent(
    lazyModule,
    m => m.MailLeftPaneAsOverlay
);
